<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { getSubPage } from '@/api/pageData'

export default {
  name: 'DialogId12',
  components: { ModuleTitle },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      currentPageData: {},
      previewShow: false
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    getShadowColor,

    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        title: this.currentModule.title,
        subtitle: '',
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      getSubPage(params).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-12">
    <div class="title-container">
      <module-title :title="currentModule.title" margin-bottom="40" />
    </div>
    <div class="group-container">
      <div
        v-for="(v, i) in pageData"
        :key="`dialog9-id-${i}`"
        class="item"
      >
        <el-image :src="v.photo | imgPath" alt="avator" class="item-avator" fit="cover" />
        <div class="item-right">
          <div class="name-group">
            <p class="item-name">{{ v.name || '' }}</p>
            <el-image
              :src="require('imgs/modules/dialog-modules/id-9-medal.png')"
              alt="logo"
              class="soldier-logo"
              fit="cover"
            />
          </div>
          <p class="item-intro">{{ v.memo || '暂无' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-id-12 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title-container {
  width: 100%;
}
.group-container {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 1186px;
  gap: 30px;
  height: 570px;
  padding: 20px 0 100px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.item {
  width: 570px;
  height: 174px;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding-left: 10px;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  .item-avator {
    width: 128px;
    height: 138px;
    border-radius: 5px;
  }
}
.item-right {
  width: 383px;
  margin-left: 30px;
  .name-group {
    width: 383px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item-name {
      font-size: 17px;
      font-weight: bold;
      color: #5E9688;
    }
    .soldier-logo {
      width: 35px;
      height: 46px;
    }
  }
}
.item-intro {
  width: 383px;
  height: 100px;
  font-size: 15px;
  color: #000;
  line-height: 20px;
  margin-top: 8px;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
</style>
